class ProductDetailVariants extends Component {
	constructor(el) {
		super(el);
		this.buttons = this.$findAll('[data-variant-id]');
		this.addEventListeners();
		EventBus.getInstance().addEventListener('initialized', () => this.resolveFirstLoad())
	}

	resolveFirstLoad() {
		// From URL fragment
		const loadedVariant = window.variantData.find(variant => variant.id === +window.location.hash.substring(1))
		if (loadedVariant) {
			this.changeVariant(loadedVariant.id)
			return
		}

		// Else try first variant
		const firstVariant = window.variantData[0]
		if (firstVariant) {
			this.changeVariant(firstVariant.id)
			return
		}
	}

	changeVariant(variantId) {
		const selectedVariant = window.variantData.find(variant => variant.id === +variantId)
		if (selectedVariant === undefined) return

		EventBus.getInstance().dispatchEvent('productVariantChanged', selectedVariant)
	}

	onVariantChange(el) {
		this.changeVariant(el.dataset.variantId)
	}

	onProductVariantChanged({detail: variant}) {
		for (const button of this.buttons) {
			button.classList.remove('is-active')
			if (button.dataset.variantId.toString() === variant.id.toString()) { // pouze 2 rovnítka, použít coersion int to string
				button.classList.add('is-active')
			}
		}

		window.location.replace('#' + variant.id);
	}

	addEventListeners() {
		this.buttons.forEach(button => button.addEventListener('click', () => this.onVariantChange(button)));
		EventBus.getInstance().addEventListener('productVariantChanged', e => this.onProductVariantChanged(e));
	}
}
